import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const FALLBACK = {
  business_name: "Cirencester 4x4",
  tagline: "Specialist 4x4 & SUV Sales",
  address_line1: "[Address line 1 placeholder]",
  address_line2: "",
  town: "Cirencester",
  county: "Gloucestershire",
  postcode: "[GL7 XXX]",
  phone: "07730 432 823",
  phone_href: "+447730432823",
  whatsapp: "447730432823",
  email: "hello@cirencester4x4.co.uk",
  directions_url: "https://www.google.com/maps/search/?api=1&query=Cirencester",
  map_embed_url: "",
  opening_hours: [],
  what3words: "",
  reservation_amount: 250,
  reservation_terms: "",
  legal: {},
  socials: {},
  integrations: {},
  company_details: "",
  finance_disclosure: "",
  finance_apr_note: "Finance figures are illustrative until connected to an approved finance provider.",
};

const SiteContext = createContext(FALLBACK);

export function SiteProvider({ children }) {
  const [site, setSite] = useState(FALLBACK);
  useEffect(() => {
    let alive = true;
    api
      .get("/settings")
      .then((r) => { if (alive && r?.data) setSite({ ...FALLBACK, ...r.data }); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);

export const fullAddress = (s) =>
  [s.address_line1, s.address_line2, s.town, s.county, s.postcode].filter(Boolean).join(", ");

export const What3Words = ({ site, className = "", testid }) => {
  const words = (site.what3words || "").replace(/^\/+/, "");
  if (!words) return null;
  return (
    <a href={`https://what3words.com/${words}`} target="_blank" rel="noreferrer" className={`link-u block ${className}`} data-testid={testid} aria-label={`what3words address ${words}`}>
      ///{words}
    </a>
  );
};
